export default __webpack_public_path__ + "static/media/OUVERTURE.ed535ffe.gif";